export const enum CustomMessageType {
    Text = 'Text',
    CSI = 'CSI',
    CSICommentRequest = 'CSICommentRequest',
    CSIThanks = 'CSIThanks',
    CSIStarsResult = 'CSIStarsResult',
    InformationBanner = 'InformationBanner',
}
